<template>
    <div
        :id="id"
        :class="classString"
    >
        <h2 class="lni-u-heading--3">
            {{ text.supportingDocuments }}
        </h2>
        <p class="lni-u-mt2">
            {{ text.documentsDisclaimer }}
        </p>
        <div class="lni-u-mt2 lni-u-mb1 lni-u-form-width--base">
            <lni-select
                :id="`${id}_upload_document-type`"
                :options="documentOptions"
                labelText="Select document type"
                class="lni-u-full-width"
            />
        </div>
        <lni-file-upload-form
            :id="`${id}_upload`"
            title=""
            :hasVideos="true"
            :sizeLimit="20971520"
            :fileLimit="10"
            :fileTypes="fileTypes"
            :multiple="false"
            :charLimit="200"
            :uploadAction="`${id}/upload`"
        >
            <template
                slot="uploads"
            >
                <div :id="`${id}_toggler`">
                    <lni-file-uploads
                        :id="`${id}_file-uploads`"
                        :allowDelete="true"
                        @deleted="onDeleted"
                    />
                </div>
            </template>
        </lni-file-upload-form>
    </div>
</template>

<script>
export default {
    name : 'LniChildLaborComplaintDocuments',
    props: {
        classString: {
            type   : String,
            default: '',
        },
        text: {
            type    : Object,
            required: true,
        },
    },
    computed: {
        documentOptions() {
            return this.$store.getters['appState/documentOptions'];
        },
    },
    methods: {
        onDeleted(files) {
            this.$store.commit('setAttribute', {
                id       : `${ this.id }_upload`,
                attribute: 'uploadedFiles',
                value    : files,
            }, { root: true });

            this.$store.commit('appState/SET_DOCUMENTS', files, { root: true });
        },
    },
};
</script>